import { AiOutlineClose } from "react-icons/ai";

const CloseIcon = (props) => {
    return <AiOutlineClose style={props.style ? props.style : {color: 'black', fontSize: '1rem'}} />
}

export default CloseIcon;